<template>
  <Modal
    :visible="isOpen"
    :size="size"
    @ok="handleOk"
    @cancel="handleCancel"
    class="h-5/6"
  >
    <div>
      <div class="modal-body">
        <div class="category-header">
          <div class="list-link">
            <div
              class="item-link"
              v-for="(category, index) in imageCategories"
              :key="`link-move-${index}`"
            >
              <div
                :class="[
                  'item-link__inner',
                  selectedCategory && selectedCategory.id === category.id ? 'active' : ''
                ]"
              >
                <a class="link-content" @click="onSelectCategory(category)"
                  >{{ category.imageCategoryNm }} ({{ category.count }})
                </a>
              </div>
            </div>
          </div>
          <div v-if="numberOfImage" class="current-image-num">
            {{ activeIndex + 1 }}/{{ totalImage }}
          </div>
        </div>
        <!-- <CarouselThumbnail previewOnly :slides="loadSlides" @change="activeImage = $event"/> -->
        <BasicCarousel
          :images="loadSlides"
          :isShowThumbnail="false"
          :imageFull="true"
          :isShowIndicator="false"
        />
      </div>
      <div class="modal-footer">
        <p v-if="activeImage">
          {{ activeImage.alt }}
        </p>
      </div>
    </div>
  </Modal>
</template>

<script>
// import _ from 'lodash'
import { Modal } from '@/components/primitive'

export default {
  components: {
    Modal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    numberOfImage: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'large' // small, medium, large
    },
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    selectedImage: {
      default: null
    },
    categoryImage: {
      default: null
    }
  },
  data() {
    return {
      isOpen: false,
      selectedCategory: null,
      activeImage: null,
      dataBinding: [],
      slides: [],
      dataImg: {},
      ImgCategory: [],
      activeIndex: 0,
      totalImage: 0
    }
  },
  beforeMount() {
    this.dataImg = this.value
  },
  mounted() {
    if (this.visible) {
      this.isOpen = this.visible
    }
    if (this.value) {
      this.dataBinding = this.value
    }
  },
  watch: {
    visible(val) {
      this.isOpen = val
    },
    value(val) {
      this.dataBinding = val
    },
    selectedImage() {
      this.selectedCategory = null
      if (this.categoryImage) {
        this.onSelectCategory(this.categoryImage)
      }
    }
  },

  computed: {
    imageCategories() {
      return this.dataBinding.map((el) => {
        return {
          id: el.id,
          imageCategoryCd: el.imageCategoryCd,
          imageCategoryNm: el.imageCategoryNm,
          count: el.images ? el.images.length : 0
        }
      })
    },
    loadSlides() {
      let images = []
      this.dataBinding
        .filter((c) => (this.selectedCategory ? this.selectedCategory.id === c.id : c.id))
        .forEach((e) => {
          images = images.concat(e.images)
        })
      return images
    }
  },
  methods: {
    statusSelect(category, index) {
      for (let i = 0; i < this.dataPhotoGallery.length; i++) {
        if (this.dataPhotoGallery[i].status !== this.dataPhotoGallery[index].status) {
          this.dataPhotoGallery[i].status = false
        }
      }
      category.status = !category.status
    },

    onSelectCategory(category) {
      if (this.selectedCategory && this.selectedCategory.id === category.id) {
        this.selectedCategory = null
      } else {
        this.selectedCategory = category
      }
    },
    onChangeCarousel($event) {
      this.activeIndex = $event.index
      this.totalImage = $event.total
    },
    handleOk() {
      this.selectedCategory = null
      this.$emit('ok')
    },
    handleCancel() {
      this.selectedCategory = null
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
@import './styles.scss';
</style>
